import type { User as FirebaseUser } from "firebase/auth";

/** The signed-in user, as the rest of the app sees it. */
export type AuthUser = FirebaseUser;

/**
 * Name to show / denormalize for a user: their display name, else the local
 * part of their email, else `fallback`. Used everywhere a write records who
 * did something (plannerName, creatorName, addedByName…).
 */
export function displayNameOf(
  user: { displayName?: string | null; email?: string | null } | null | undefined,
  fallback = "You",
): string {
  return user?.displayName || user?.email?.split("@")[0] || fallback;
}
